"use client";

import { useEffect } from "react";
import { trackEvent } from "@/lib/gtag";

// 사이트 검색 추적 — /programs?q= 검색 시 GA4 'search' 이벤트 전송(search_term).
//   서버 폼 GET 이라 페이지 로드마다 실행되며, 같은 검색어 중복 전송 방지 위해 term 변경 시에만.
export function SearchTrack({ term }: { term: string }) {
  useEffect(() => {
    const q = term.trim();
    if (q) trackEvent("search", { search_term: q });
  }, [term]);
  return null;
}
